import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

// One codebase, two sites. REACT_APP_SURFACE=admin (`npm run build:admin`,
// `npm run start:admin`) builds admin.wavelengtherp.com, the Wavelength team's
// console; the default (.env: dashboard) builds wavelengtherp.com. The value is
// fixed at build time, so the branch not taken is dropped from the bundle and
// neither site ships the other's code.
const App = process.env.REACT_APP_SURFACE === 'admin'
    ? require('./admin/AdminApp').default
    : require('./App').default;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
